import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Layout from "../Layout";
import List from "../Components/Meeting Request/List";
import View from "../Components/Meeting Request/View";
import Add from "../Components/Meeting Request/Add";

function MeetingRequest() {
  const [comp, setComp] = useState("list");
  const [rowData, setRowData] = useState();
  const location = useLocation();
  const [currentOrder, setCurrentorder] = useState({});
  useEffect(() => {
    setComp("list");
  }, [location]);

  function handleChange(newValue) {
    setComp(newValue.mode);
    setRowData(newValue.rowData);
  }

  // const routeTitles = {
  //   "/marketing/your-meeting-request": "Your Meeting Requests",
  //   "/marketing/team-meeting-request": "Team Meeting Requests",
  //   "/marketing/meeting-request": "Meeting Requests",
  // };

  // const pageTitle = routeTitles[location.pathname] || "Meeting Requests";

  function renderComponent() {
    switch (comp) {
      case "list":
        return (
          <List
            comp={comp}
            onChange={handleChange}
            rowData={rowData}
            setCurrentorder={setCurrentorder}
          />
        );
      case "view":
        return <View comp={comp} rowData={rowData} setComp={setComp} onChange={handleChange} />;

      // case "brand":
      //   return (
      //     <BrandSales
      //       comp={comp}
      //       rowData={rowData}
      //       onChange={handleChange}
      //       currentOrder={currentOrder}
      //     />
      //   );
      // case "sales":
      //   return (
      //     <Sales
      //       comp={comp}
      //       rowData={rowData}
      //       onChange={handleChange}
      //       currentOrder={currentOrder}
      //     />
      //   );

      default:
        return (
          <Add
            comp={comp}
            rowData={rowData}
            onChange={handleChange}
            currentOrder={currentOrder}
          />
        );
    }
  }

  useEffect(() => {
    if (rowData) {
      console.log(rowData);
    }
  }, [rowData]);
  return (
    <Layout>
      <div className="main-content">
        <section className="section">
          <div className="section-header">
            <h1>Meeting</h1>
          </div>
          {renderComponent()}
        </section>
      </div>
    </Layout>
  );
}

export default MeetingRequest;
